import { useRef, useCallback } from 'react'

export interface ScrollableRefHandle {
  scrollToMethod: (methodId: string) => void
}

export const useScrollableRef = () => {
  const methodRefs = useRef<Record<string, HTMLDivElement | null>>({})

  const scrollToMethod = useCallback((methodId: string) => {
    const element = methodRefs.current[methodId]
    if (!element) return

    // Find the scrollable container
    let scrollContainer = element.closest('[class*="overflow-"]')
    if (!scrollContainer) {
      scrollContainer = element.closest('div')
      while (scrollContainer && scrollContainer.scrollHeight <= scrollContainer.clientHeight) {
        scrollContainer = scrollContainer.parentElement
      }
    }

    if (scrollContainer) {
      const elementRect = element.getBoundingClientRect()
      const containerRect = scrollContainer.getBoundingClientRect()

      const scrollTop =
        scrollContainer.scrollTop +
        (elementRect.top - containerRect.top) -
        containerRect.height / 2 +
        elementRect.height / 2

      scrollContainer.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      })
    }
  }, [])

  const setMethodRef = useCallback(
    (methodId: string) => (node: HTMLDivElement | null) => {
      methodRefs.current[methodId] = node
    },
    []
  )

  return {
    methodRefs: methodRefs.current,
    setMethodRef,
    scrollToMethod
  }
}
